// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2S9NZ","sendOtp":"AuthorizeToLogin_sendOtp__188XT"};